import { getObjectId } from '@/helpers/object.id.helper';
import type { FlowDto } from '@/types/dtos/flows/response/flow.dto';

/** Scoped PLAN instance document (origin points at master PLAN, id differs). */
export function isScopedPlanFlowDto(flow: FlowDto): boolean {
  if (flow.mode !== 'PLAN') return false;
  const originId = flow.origin ? getObjectId(flow.origin) : flow.id;
  return flow.id !== originId;
}

/** Master flow rows for event lists (dashboard / flows tab) — excludes scoped PLAN and PLAY. */
export function masterFlowsForEventList(flows: FlowDto[] | undefined): FlowDto[] {
  return (flows ?? []).filter((flow) => flow.mode !== 'PLAY' && !isScopedPlanFlowDto(flow));
}
